import $ from 'jquery'
import React from 'react'
import { render } from 'react-dom'
import parseAttributeJson from '../shared/parse.attribute.json'
import { Provider } from 'react-redux'
import store from '../redux/store'

export default function mountReactRedux() {
  $('[data-redux-react-class]').each(function(index, el) {
    let $el = $(el)

    let className = $el.attr('data-redux-react-class')
    let props = parseAttributeJson($el.attr('data-react-props'))

    let Component = require('../components/' + className).default

    render(
      <Provider store={store}>
        <Component {...props} />
      </Provider>,
      el
    )
  })
}
